"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var prop_types_1 = __importDefault(require("prop-types"));

function SzTitle(_a) {
  var className = _a.className,
      children = _a.children,
      type = _a.type;
  var fontClassName = classnames_1.default({
    big: type === 'huge',
    'text-uppercase letter-spacing': type === 'h2'
  }, className);
  if (type === 'huge') return react_1.default.createElement("span", {
    className: fontClassName
  }, children);
  if (type === 'h1') return react_1.default.createElement("h1", {
    className: fontClassName
  }, children);
  if (type === 'h2') return react_1.default.createElement("h2", {
    className: fontClassName
  }, children);
  if (type === 'h3') return react_1.default.createElement("h3", {
    className: fontClassName
  }, children);
  return react_1.default.createElement("h1", {
    className: fontClassName
  }, children);
}

exports.default = SzTitle;
SzTitle.defaultProps = {
  type: 'h1'
};
SzTitle.propTypes = {
  type: prop_types_1.default.oneOf(['huge', 'h1', 'h2', 'h3']),
  children: prop_types_1.default.string.isRequired
};